import { useContext , createContext, useState } from "react"
import SummaryApi from "../common";
import {toast} from 'react-toastify';
export const ProjectContext = createContext();

export const ProjectProvider = ({children}) =>{

    const [projectData,setProjectData] = useState([]);
    const [isLoading,setLoading] = useState(false);
    const [staff,setStaff] = useState([]);

    //pagination related
    const ITEMS_PER_PAGE = 6;
    const [currentPage,setCurrentPage] = useState(1); //current page user looking at

    //salice logic      1   -  1 = 0     *    5 = 0 
    //                  2   -  1 = 1     *    5 = 5
    const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
    //                   0      +   6     = 6
    //                   5      +   6     = 11                  
    const endIndex = startIndex + ITEMS_PER_PAGE;
    //                                              0          6     = from index 0 to 5 data show for page 1                                               
    //                                              5          11    = from index 5 to 10 data show for page 2
    const paginationProjects = projectData.slice(startIndex,endIndex);

    const totalPages = Math.ceil(projectData.length/ITEMS_PER_PAGE);
    
    //methods for pagination
    const gotoPage = (pageNumber) => {
        setCurrentPage(pageNumber); //overwrite
    }

    const nextPage = () =>{
        setCurrentPage((prevPage)=>{
          if(prevPage < totalPages){
              return prevPage + 1  
          }  
         });
    }

    const prevPage = () =>{
        setCurrentPage((prevPage)=>{
            if(prevPage > 1){
                return prevPage - 1
            }
        }); 
    }


    //utility method
    const sortByGroup = (newData) =>{
        //during add/update/pinned
        newData.sort((a,b)=>{
            const pinned = b.isPinned - a.isPinned;
            if(pinned != 0){
                return pinned;
            }
            return new Date(b.updatedAt) - new Date(a.updatedAt);
        })
        console.log('newData',newData);
        return newData;
    }

    //Project data fetch related methods

    const addProject = async(projectData) => {
        try{

            const response = await fetch(SummaryApi.addProject.url,{
                method:SummaryApi.addProject.method,
                headers:{
                    "Content-Type":"application/json",
                },
                body: JSON.stringify(projectData)
            })
    
            const data = await response.json();
            if(!response.ok){
                toast.error(data.message);
                console.log(data.message);
                return;
            }
            toast.success(data.message);    

            setProjectData((prevState)=>{
                const newData = [...prevState,data.project];

                return sortByGroup(newData);
            });
            
            // getProject(); // side effect
        }catch(err){
            console.log('error in adding project',err);
        }
    }

    const getProject = async() =>{
        setLoading(true);
        try{
            const response = await fetch(SummaryApi.getProjects.url,{
                method:SummaryApi.getProjects.method,
                headers:{
                    "Content-Type":"application/json",
                }
            })

            const data = await response.json();
            if(!response.ok){
                console.log(data.message);
                return;
            }
            setProjectData(data.projects);//replace with new data
            console.log(data.message,data.projects);
        }catch(err){
            console.log('error in fetching Project');
        }finally{
            setLoading(false);
        }
    }
    const updateProject = async(projectId,newProjectData) =>{
        try{
            const response = await fetch(SummaryApi.updateProject(projectId).url,{
                method:SummaryApi.updateProject(projectId).method,
                headers:{
                    "Content-Type":"application/json",
                },
                body: JSON.stringify(newProjectData)
            })

            const data = await response.json()
            if(!response.ok){
                console.log('failed to update Project');
                toast.error(data.message);
                return;
            }

            setProjectData((prevData)=>{
                const newData = prevData.map((project)=> project._id == projectId ? {...project,...data.project} : project);

                // newData.sort((a,b)=>{
                //     return new Date(b.updatedAt) - new Date(a.updatedAt);
                // })

                return sortByGroup(newData);
            })
            toast.success(data.message);
        }catch(err){
            console.log('error updating project');
            toast.error('error updating project');
        }
    }

    const deleteProject = async(projectId) =>{
        try{
            const response = await fetch(SummaryApi.deleteProject(projectId).url,{
                method:SummaryApi.deleteProject(projectId).method,
                headers:{
                    "Content-Type":"application/json",
                }
            })
            const data = await response.json();

            if(!response.ok){
                console.log('failed to deleteProject');
                toast.error(data.message);
                return;
            }

            setProjectData((prevData)=>{
                const filterdData = prevData.filter((project)=> project._id != projectId);

                return filterdData;
            });

            setTimeout(()=>{
                toast.success(data.message)
            },300)
        }catch(err){
            console.log('error in  deleteing project');
            toast.error('error in deleting toast');
        }
    }

    const getAllStaff = async()=>{
        const response = await fetch(SummaryApi.staff.getAll.url,{
            method:SummaryApi.staff.getAll.method,
            headers:{
                "Content-Type":"application/json",
            }
        })

        const data = await response.json();

        if(!response.ok){
            toast.error(data.message);
            console.log('failed to fetch data')
        }
        console.log(data)
        setStaff(data);
    }

    const pinProject = async(projectId,isPinned) =>{
        try{
            const response = await fetch(SummaryApi.pinProject(projectId).url,{
                method:SummaryApi.pinProject(projectId).method,
                headers:{
                    "Content-Type":"application/json",
                },
                body: JSON.stringify({isPinned})
            })

            const data = await response.json();

            if(!response.ok){
                toast.error(data.message);
                console.log('failed to fetch data')
            }

            setProjectData((prevState)=>{
                // miske overwrite the whole object with unpopulated data fix only update necessary fields not whole object itself 
                // const updatedData = prevState.map((project)=> project._id == data.project._id ? {...project,...data.project} : project);
                const updatedData = prevState.map((project)=> project._id == data.project._id ? {...project, isPinned: data.project.isPinned,updatedAt: data.project.updatedAt} : project);


                return sortByGroup(updatedData)
            })
        }catch(err){
            console.log('error  during pined project',err);
            toast.error('error during pined project');
        }
    }
    return (
        <ProjectContext.Provider value={{paginationProjects,currentPage,totalPages,isLoading,staff,pinProject,getAllStaff,gotoPage,nextPage,prevPage,addProject,getProject,updateProject,deleteProject}}>
            {children}
        </ProjectContext.Provider>
    )
}

export default ProjectProvider;